export const MENU_DATA = [
  {
    label: 'Shop',
    items: [
      {
        label: 'Personalised vitamins',
        link: `${process.env.GATSBY_VITL_HOST_NAME}/shop/personalised`,
      },
      {
        label: 'All vitamins',
        link: `${process.env.GATSBY_VITL_HOST_NAME}/shop/vitamins`,
      },
      {
        label: 'DNA & Blood tests',
        link: `${process.env.GATSBY_VITL_HOST_NAME}/shop/tests`,
      },
      {
        label: 'Special offers',
        link: `${process.env.GATSBY_VITL_HOST_NAME}/shop/special-offers`,
      },
      { label: 'Shop all', link: `${process.env.GATSBY_VITL_HOST_NAME}/shop` },
    ],
  },
  {
    label: 'Learn',
    items: [
      { label: 'About Us', link: `${process.env.GATSBY_VITL_HOST_NAME}/about` },
      {
        label: 'Science',
        link: `${process.env.GATSBY_VITL_HOST_NAME}/science`,
      },
      { label: 'FAQs', link: `${process.env.GATSBY_VITL_HOST_NAME}/contact` },
    ],
  },
];
